import {
  addCommas,
  getFormattedTime,
  getPriceText,
} from '@zorba-shared/core/Services/textService';
import { MAP_PROPERTY_TYPE_TO_STRING } from '../PortfolioAggregationsTable/constants';

export const getTableColumns = ({
  isMultiFamilySelected,
  isVacantSelected,
}) => [
  {
    title: 'Seller',
    key: 'seller',
    render: ({ seller }) => seller,
  },
  {
    title: 'Buyer',
    key: 'buyer',
    render: ({ buyer }) => buyer,
  },
  {
    title: 'Address',
    key: 'address',
    render: ({ address }) => address,
  },
  {
    title: 'State',
    key: 'state',
    render: ({ state }) => state,
  },
  {
    title: 'Property Type',
    key: 'propertyType',
    render: ({ propertyType }) => MAP_PROPERTY_TYPE_TO_STRING[propertyType],
  },
  ...(isMultiFamilySelected
    ? [
        {
          title: 'Units count',
          key: 'unitsCount',
          render: ({ unitsCount }) => unitsCount,
        },
      ]
    : []),
  ...(isVacantSelected
    ? [
        {
          title: 'Lot size',
          key: 'lotSize',
          render: ({ lotSize }) =>
            lotSize ? `${addCommas(lotSize)} sqft` : '',
        },
      ]
    : []),
  {
    title: 'Title company name',
    key: 'titleCompanyName',
    render: ({ titleCompanyName }) =>
      titleCompanyName !== 'NONE LISTED ON DOCUMENT' ? titleCompanyName : '',
    sorter: (a, b, sortOrder) => {
      const nameA =
        a.titleCompanyName && a.titleCompanyName !== 'NONE LISTED ON DOCUMENT'
          ? a.titleCompanyName
          : '';
      const nameB =
        b.titleCompanyName && b.titleCompanyName !== 'NONE LISTED ON DOCUMENT'
          ? b.titleCompanyName
          : '';

      if (nameA === '' && nameB === '') return 0;
      if (nameA === '') return sortOrder === 'ascend' ? 1 : -1;
      if (nameB === '') return sortOrder === 'ascend' ? -1 : 1;

      return nameA.localeCompare(nameB);
    },
  },
  {
    title: 'Sale price',
    key: 'salePrice',
    render: ({ salePrice }) => getPriceText(salePrice),
  },
  {
    title: 'AVM',
    key: 'avm',
    render: ({ avm }) => getPriceText(avm),
  },
  {
    title: 'Transaction date',
    key: 'transactionDate',
    render: ({ transactionDate }) => getFormattedTime(transactionDate),
  },
  {
    title: 'Lender name',
    key: 'lenderName',
    render: ({ lenderName }) => lenderName,
  },
  {
    title: 'Mortgage borrower',
    key: 'mortgageBorrower',
    render: ({ mortgageBorrower }) => mortgageBorrower,
  },
  {
    title: 'Mortgage amount',
    key: 'mortgageAmount',
    render: ({ mortgageAmount }) => getPriceText(mortgageAmount),
  },
  {
    title: 'Mortgage date',
    key: 'mortgageDate',
    render: ({ mortgageDate }) => getFormattedTime(mortgageDate),
  },
  {
    title: 'Mortgage interest rate',
    key: 'mortgageInterestRate',
    render: ({ mortgageInterestRate }) =>
      mortgageInterestRate ? `${mortgageInterestRate}%` : '',
  },
  {
    title: 'Mortgage term',
    key: 'mortgageTerm',
    render: ({ mortgageTerm }) => mortgageTerm,
  },
  {
    title: 'Mortgage term type',
    key: 'mortgageTermType',
    render: ({ mortgageTermType }) => mortgageTermType,
  },
];
